// public/debounce-utils.js
// Utility functions for debouncing and throttling

/**
 * Debounce function - delays execution until after wait period of inactivity
 * @param {Function} func - Function to debounce
 * @param {number} wait - Milliseconds to wait
 * @returns {Function} Debounced function
 */
export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

/**
 * RequestAnimationFrame-based throttle for smooth visual updates
 * @param {Function} func - Function to throttle
 * @returns {Function} RAF-throttled function
 */
export function rafThrottle(func) {
  let rafId = null;
  let latestArgs = null;

  return function executedFunction(...args) {
    latestArgs = args;

    if (rafId === null) {
      rafId = requestAnimationFrame(() => {
        func(...latestArgs);
        rafId = null;
        latestArgs = null;
      });
    }
  };
}
